import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _DELETE_QUOTATION_ } from './QuotationModel';

export default {
  name: 'quotation-delete',
  data() {
    return {
      selectedQuotation: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.deleteQuotation(this.selectedQuotation)
        .then(() => {
          this.close();
          this.$router.push('/admin/orcamentos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Orçamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_QUOTATION_, quotation => {
      this.selectedQuotation = quotation.id;
    });
  },
};
